import { defineStore } from 'pinia';
import type { ReviewExtendedState } from '~~/types/vuex/ReviewExtended';

export const reviewExtendedStore = defineStore('reviewExtended', {
  state: () => ({ sortParam: [] as ReviewExtendedState['sortParam'] | null }),
  actions: {
    setSortParam(payload: ReviewExtendedState['sortParam'] | null) {

      this.sortParam = payload; 

    },
  },
});
